import { FullColumnName } from '@models/column';

export type Filter =
  | And
  | Above
  | Below
  | Between
  | FullPass
  | HourOfDay
  | NgramFilter
  | Value
  | Weekday
  | Weekend;

export namespace Filter {
  export enum Type {
    AndFilter = 'AndFilter',
    Above = 'Above',
    Below = 'Below',
    Between = 'Between',
    FullPass = 'FullPass',
    HourOfDay = 'HourOfDay',
    NgramFilter = 'NgramFilter',
    Value = 'Value',
    Weekday = 'Weekday',
    Weekend = 'Weekend',
  }
}

export interface And {
  type: Filter.Type.AndFilter;
  filter1: Filter;
  filter2: Filter;
}

export interface Above {
  type: Filter.Type.Above;
  column: FullColumnName;
  min_inclusive: number;
}

export interface Below {
  type: Filter.Type.Below;
  column: FullColumnName;
  max_exclusive: number;
}

export interface Between {
  type: Filter.Type.Between;
  column: FullColumnName;
  min_inclusive: number;
  max_exclusive: number;
}

export interface FullPass {
  type: Filter.Type.FullPass;
}

export interface HourOfDay {
  type: Filter.Type.HourOfDay;
  column: FullColumnName;
  min_hour_inclusive: number;
  max_hour_exclusive: number;
}

export interface NgramFilter {
  type: Filter.Type.NgramFilter;
  column: FullColumnName;
  ngram: string[];
}

export interface Value {
  type: Filter.Type.Value;
  column: FullColumnName;
  value: boolean | string | number;
}

export interface Weekday {
  type: Filter.Type.Weekday;
  column: FullColumnName;
}

export interface Weekend {
  type: Filter.Type.Weekend;
  column: FullColumnName;
}
